/*
 * SPDX-FileCopyrightText: 2023-2024 CERN.
 * SPDX-License-Identifier: MIT
 */

import React from "react";
import { Icon } from "semantic-ui-react";

export const AccessRequestIcon = () => (
  <Icon name="unlock alternate" className="neutral" />
);
export const CommunityInclusionIcon = () => <Icon name="plus" className="neutral" />;
export const CommunityInvitationIcon = () => (
  <Icon name="user plus" className="neutral" />
);
